import { SmartTable } from '../../../../../components/smart-table/smart-table.model';
import { accountFromDto } from '../../account.dto';

export class Controller {

    /** @ngInject */
    constructor($q, $state, $uibModal, AccountsResource, Alert, UsersResource) {
        this.$q = $q;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
        this.UsersResource = UsersResource;
    }

    $onInit() {
        this.username = '';
        this.searchText = '';
        this.lastSearchText = '';
        this.form = 'newForm';
        this.st = new SmartTable();
    }

    focusNewForm() {
        this.form = 'newForm';
        this.searchText = '';
        this.lastSearchText = '';
        this.accounts = null;
    }

    focusExistingForm() {
        this.form = 'existingForm';
        this.username = '';
    }

    save() {

        const addAccount = () => {
            if (this.companyUser.id) {
                return this.UsersResource
                    .addNewAccountForUser(this.companyId, this.companyUser, this.username)
                    .then(rejectAlreadyExistingAccount)
                    .then(account => this.accountsForCompanyUser.push(account))
            } else {
                return this.UsersResource
                    .addHardtokenUserWithAccount(this.companyId, this.companyUser, this.username)
                    .then(companyUser => Object.assign(this.companyUser, companyUser))
            }
        };

        const rejectAlreadyExistingAccount = (account) => {
            if (account.justCreated) {
                return this.$q.resolve(account);
            } else {
                this.$uibModal
                    .open({component: 'companyUserDirectoriesManageUserAddAccountAccountAlreadyExists'}).result
                    .then(() => this.$state.go('company.user-directories.manage-account', {accountId: account.id}));
                return this.$q.reject();
            }
        };

        const verifyAccount = (account) => {
            return this.AccountsResource
                .verifyAccount(this.companyId, account.id, this.companyUser)
                .then(() => {
                    this.accountsForCompanyUser
                        .push(accountFromDto(
                            {...account, isSelected: false, status: 'ACTIVE'},
                            this.companyUser
                        ))
                })
        };

        const redirect = () => {
            if (this.companyUser.id) {
                return this.$state.go('^', {companyUserId: this.companyUser.id})
            } else {
                // first account is added (inactive hard-token), and company user is created
                return this.UsersResource
                    .getCompanyUserForSaaspassUser(
                        this.companyId,
                        this.companyUser.saaspassUser.saaspassId,
                    )
                    .then(companyUser => this.$state.go('^', {companyUserId: companyUser.id}))
            }
        };

        this.isSaving = true;
        if (this.form === 'newForm') {
            addAccount()
                .then(redirect)
                .then(() => this.Alert('success', 'company.user-directories.manage-user.accounts.add.added-new'))
                .finally(() => this.isSaving = false)
        } else if (this.st.selectedItems.length) {
            verifyAccount(this.st.selectedItems[0])
                .then(redirect)
                .then(() => this.Alert('success', 'company.user-directories.manage-user.accounts.add.added-existing'))
                .finally(() => this.isSaving = false)
        }
    }

    saveDisabled() {
        return this.isSaving || this.isSearching ||
            this.form === 'newForm' && !this.username ||
            this.form === 'existingForm' && !this.st.selectedItems.length;
    }

    search() {
        this.isSearching = true;
        this.accounts = null;
        this.AccountsResource
            .getAccountsByUsername(this.companyId, '', this.searchText)
            .then((accounts) => accounts.filter(({status, accountType}) =>
                status !== 'ACTIVE' && !['EXTERNAL_EMAIL', 'PHONENUMBER'].includes(accountType)
            ))
            .then((accounts) => {
                this.accounts = accounts;
                this.lastSearchText = this.searchText;
            })
            .finally(() => this.isSearching = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/add-account/add-account.controller.js